import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ApiClientService} from '../../../services/api-client.service';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import {PassOnLog, ResidentForSelect} from '../../../types/data.types';
import {PassOnLogService} from '../../../services/pass-on-log.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;
declare const moment: any;

@Component({
    selector: 'pass-on-log-modal',
    templateUrl: './pass-on-log-modal.component.html',
    styleUrls: ['./pass-on-log-modal.component.scss']
})
export class PassOnLogModalComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    suites: Array<any> = [];
    residents: Array<ResidentForSelect> = [];
    data: PassOnLog = new PassOnLog();
    disabledSubmit = false;
    startDate: string = (new Date).toISOString();
    endDate: string = (new Date).toISOString();

    constructor(
        public api: ApiClientService,
        public passOnLogService: PassOnLogService,
        public urlService: UrlService
    ) {}

    ngOnInit() {
        this.initData();
        setTimeout( () => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    initData() {
        if (this.passOnLogService.passOnLogInPassOnLogModal) {
            this.data = this.passOnLogService.passOnLogInPassOnLogModal;
            this.startDate = this.data.startDate.replace('+00:00', '');
            this.endDate = this.data.endDate.replace('+00:00', '');
        } else {
            const b = this.urlService.queryParams['building'];
            if (b) {
                this.data.buildingId = b;
            }

            if (this.passOnLogService.buildingsForUpdate.length === 1) {
                this.data.buildingId = this.passOnLogService.buildingsForUpdate[0].id;
            }
        }
    }

    hideModal() {
        if (this.form.dirty && this.form.touched) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    this.passOnLogService.isPassOnLogModalShow = false;
                    this.passOnLogService.passOnLogInPassOnLogModal = null;
                    this.urlService.modalClosed.emit();
                }
            );
        } else {
            this.passOnLogService.isPassOnLogModalShow = false;
            this.passOnLogService.passOnLogInPassOnLogModal = null;
            this.urlService.modalClosed.emit();
        }
    }

    onSubmit(form: NgForm) {
        if (!form.valid) {
            if (!form.value.buildingId) toastr.warning('Building should not be blank.');
            if (!form.value.subject) toastr.warning('Subject must be entered.');
            if (!form.value.announcement) toastr.warning('Announcement should not be blank.');
            if (!form.value.startDate) toastr.warning('Start Date should not be blank.');
            // if (!form.value.endDate) toastr.warning('End Date should not be blank.');
            return;
        }

        const sDate = new Date(form.value.startDate).setHours(0, 0, 0, 0);
        if (form.value.endDate && (new Date(sDate) > new Date(form.value.endDate))) {
            toastr.warning('End Date should not be earlier than Start Date.');
            return;
        }

        const building = this.passOnLogService.buildings.find((item) => item.id == form.value.buildingId);

        const data: any = {
            building: {
                bdId: form.value.buildingId,
                name: building ? building.name : null,
            },
            subject:          form.value.subject,
            announcement:     form.value.announcement,
            startDate:        moment(form.value.startDate).format('YYYY-MM-DD'),
            endDate:          form.value.endDate ? moment(form.value.endDate).format('YYYY-MM-DD') : undefined
        };

        this.disabledSubmit = true;

        if (this.data.id) {
            this.api.patch('domainPassOnLog', `/v1/pass_on_log/${this.data.id}.json`, data).subscribe(
                () => this.updateView('Pass On Log successfully updated'),
                error => {
                    this.disabledSubmit = false;
                    this.api.errorHandler(error, 'Edit Pass On Log failed');
                }
            );
        } else {
            this.api.post('domainPassOnLog', '/v1/pass_on_log.json', data).subscribe(
                () => this.updateView('Pass On Log successfully created'),
                error => {
                    this.disabledSubmit = false;
                    this.api.errorHandler(error, 'Create Pass On Log failed');
                }
            );
        }
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.passOnLogService.getData();
        this.form.reset();
        this.hideModal();
    }

    onStartDateChange(): void {
        if(new Date(this.startDate) > new Date(this.endDate)) {
            this.endDate = null;
            this.form.value.endDate = null;
        }
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/pass-on-log/pass-on-log-modal/pass-on-log-modal.component.ts